// extracted by mini-css-extract-plugin
export default {"leadDetailsFieldName":"leadDetailsFieldName___ECAfQ","leadDetailsFieldValue":"leadDetailsFieldValue___zz12Q"};